import type { ApiTokenKeyType } from "@performyard/models";

import request from "../base-request";

export interface IApiKey {
	_id: string;
	name: string;
	last_used_at: Date | null;
	enabled: boolean;
	company_id: string;
	user_id: string;
	api_token_id: string;
	api_key: string;
	key_type?: ApiTokenKeyType;
}

export interface RequestResponse<T> {
	data: T;
	errors: unknown[];
}

export const getApiKeys = async (column: string, direction: string): Promise<RequestResponse<IApiKey[]>> => {
	const [response] = await request<RequestResponse<IApiKey[]>>(
		"/api-key?column=" + column + "&direction=" + direction + ""
	);

	response.data.map((apiKey) => {
		if (apiKey.last_used_at && typeof apiKey.last_used_at === "string") {
			apiKey.last_used_at = new Date(apiKey.last_used_at);
		} else {
			apiKey.last_used_at = null;
		}
	});

	return response;
};

export const getApiKeyById = async (id: string): Promise<RequestResponse<IApiKey>> => {
	const [response] = await request<RequestResponse<IApiKey>>(`/api-key/${id}/`);
	return response;
};

export const createApiKey = async (
	data: Pick<IApiKey, "name" | "enabled" | "key_type">
): Promise<RequestResponse<IApiKey>> => {
	const [response] = await request<RequestResponse<IApiKey>>("/api-key", {
		method: "POST",
		body: JSON.stringify(data),
	});

	return response;
};

export const recycleApiKey = async (
	data: Pick<IApiKey, "name" | "enabled" | "_id">
): Promise<RequestResponse<IApiKey>> => {
	const [response] = await request<RequestResponse<IApiKey>>(`/api-key/${data._id}/recycle`, {
		method: "POST",
		body: JSON.stringify({ name: data.name, enabled: data.enabled }),
	});
	return response;
};

export const deleteApiKey = async (id: string): Promise<void> => {
	await request<{ success: boolean }>(`/api-key/${id}/`, {
		method: "DELETE",
	});
};

export const updateApiKey = async (data: Pick<IApiKey, "name" | "enabled" | "_id">): Promise<IApiKey> => {
	const [response] = await request<IApiKey>(`/api-key/${data._id}/`, {
		method: "PATCH",
		body: JSON.stringify({ name: data.name, enabled: data.enabled }),
	});
	return response;
};
